export default "__VITE_ASSET__DlyK5t6L__"